import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=56437695&scoped=true"
import script from "./DashboardView.vue?vue&type=script&lang=js"
export * from "./DashboardView.vue?vue&type=script&lang=js"
import style0 from "./DashboardView.vue?vue&type=style&index=0&id=56437695&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56437695",
  null
  
)

export default component.exports